<template>
  <GoogleMapLoader
    :mapConfig="mapConfig"
    :apiKey="apiKey"
    :google="google">
    <template slot-scope="{ google, map }">
      <MapLegend
        :isInMapSearchPage="true"/>
      <GoogleMapMarkers
        :gardens="gardens"
        :google="google"
        :map="map"
        :addInfoWindows="true"
      />

      <GoogleMapMarkerClusterer
        :gardens="gardens"
        :google="google"
        :map="map"
      />
    </template>
  </GoogleMapLoader>
</template>

<script>
import { mapGetters } from 'vuex'

import GoogleMapsApiLoader from 'google-maps-api-loader'
import eventBus from '@/services/eventBus'

import GoogleMapLoader from '@/components/map/GoogleMapLoader'
import GoogleMapMarkers from '@/components/map/GoogleMapMarkers'
import GoogleMapMarkerClusterer from '@/components/map/GoogleMapMarkerClusterer'
import MapLegend from '@/components/map/MapLegend'

import { mapSettings } from '@/components/map/constants/mapSettings'

export default {
  name: 'SearchMapWrapper',

  components: {
    GoogleMapLoader,
    GoogleMapMarkers,
    GoogleMapMarkerClusterer,
    MapLegend,
  },

  data: () => ({
    apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    google: null,
    initialiseMap: false,
    mapCenter: {
      lat: 0,
      lng: 0,
    },
  }),

  async mounted() {
    const googleMapApi = await GoogleMapsApiLoader({
      apiKey: this.apiKey,
    })

    this.google = googleMapApi
  },

  computed: {
    ...mapGetters('garden', [
      'gardens',
    ]),

    ...mapGetters('location', [
      'selectedLocation',
    ]),

    ...mapGetters('map', [
      'mapBounds',
      'geoBoundingBox',
      'searchBounds',
    ]),

    ...mapGetters('filter', [
      'sectionFilterSelected',
    ]),
    isMobile() {
      return window.innerWidth >= 479 && window.innerWidth < 767;
    },
    isMobileSmall() {
      return window.innerWidth >= 380 && window.innerWidth < 479;
    },
    isMobileTiny() {
      return window.innerWidth < 380;
    },

    mapConfig() {
      return {
        ...mapSettings,
        center: this.mapCenter,

        minZoom: this.isMobileTiny
          ? 5.2
          : this.isMobileSmall
            ? 5.5
            : this.isMobile
              ? 6
              : 6.3,
        disableDefaultUI: true,
        panControlOptions: false,
        panControl: false,
        zoomControl: false,
        draggable: true,
      }
    },
    gardenSearch() {
      return this.sectionFilterSelected('garden')
    },
  },

  watch: {
    async geoBoundingBox(value) {
      if (value && this.google) {
        await this.getMapCenter()

        if (!this.initialiseMap) {
          this.initialiseMap = true
        }
      }
    },
    async google(value) {
      if (value && this.geoBoundingBox) {
        await this.getMapCenter()

        if (!this.initialiseMap) {
          this.initialiseMap = true
        }
      }
    },
    initialiseMap(value) {
      if (value && this.mapCenter) {
        eventBus.$emit('initialize-map')
      }
    },
    selectedLocation(newLocation) {
      if (newLocation) {
        this.setMapCenter()
      }
    },
  },

  methods: {
    getMapCenter() {
      return new Promise((resolve) => {
        const topRight = new this.google.maps.LatLng(this.geoBoundingBox.top_right.lat, this.geoBoundingBox.top_right.lng)
        const bottomLeft = new this.google.maps.LatLng(this.geoBoundingBox.bottom_left.lat, this.geoBoundingBox.bottom_left.lng)

        const centerBounds = new this.google.maps.LatLngBounds()
        centerBounds.extend(bottomLeft)
        centerBounds.extend(topRight)

        this.mapCenter = {
          lat: centerBounds.getCenter().lat(),
          lng: centerBounds.getCenter().lng(),
        }
        resolve()
      })
    },
    setMapCenter() {
      this.mapCenter = this.selectedLocation.geometry.location
      eventBus.$emit('reinitialize-map')
    },

  },
}
</script>

<style scoped lang='scss'>
@import '@/assets/scss/base/_variables.scss';

</style>
